export function optimizedImageUrl(
  src: string | undefined | null,
  width: number,
  quality: number = 80
): string {
  if (!src) return "";
  if (!src.startsWith("/uploads/")) return src;
  const path = src.replace(/^\/uploads\//, "");
  return `/img/${width}/${quality}/${path}`;
}
